import {
  Component, ChangeDetectionStrategy, Input, Output, EventEmitter,
} from '@angular/core';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';

/**
 * FikoYT Sayfalama Bileşeni
 *
 * Paylaşım sistemindeki pagination stili: hap şekli, gölgeli, sticky.
 *
 * Kullanım:
 * ```html
 * <fikoyt-sayfalama
 *   [toplam]="100"
 *   [sayfa]="1"
 *   [sayfaBoyutu]="10"
 *   [sayfaBoyutSecenekleri]="[10, 20, 50]"
 *   [sticky]="true"
 *   (sayfaDegisti)="sayfaDegisti($event)"
 *   (sayfaBoyutuDegisti)="boyutDegisti($event)"
 * ></fikoyt-sayfalama>
 * ```
 */
@Component({
  selector: 'fikoyt-sayfalama',
  standalone: true,
  imports: [NzPaginationModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fs-wrap" [class.fs-sticky]="sticky">
      <nz-pagination
        [nzTotal]="toplam"
        [nzPageIndex]="sayfa"
        [nzPageSize]="sayfaBoyutu"
        [nzPageSizeOptions]="sayfaBoyutSecenekleri"
        [nzSimple]="false"
        nzSize="small"
        nzShowSizeChanger
        (nzPageIndexChange)="sayfaDegisti.emit($event)"
        (nzPageSizeChange)="sayfaBoyutuDegisti.emit($event)">
      </nz-pagination>
    </div>
  `,
  styles: [`
    :host { display: block; }

    .fs-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 0;
    }

    .fs-sticky {
      position: sticky;
      bottom: 5px;
      z-index: 5;
    }

    :host ::ng-deep .ant-pagination {
      background: var(--py-sayfalama-arka, #fff);
      padding: 0 10px;
      border-radius: 2em;
      box-shadow: var(--py-sayfalama-golge, 0 2px 8px rgba(0, 0, 0, 0.1));
    }

    :host-context(.dark-mode) ::ng-deep .ant-pagination,
    :host-context(.tema-karanlik) ::ng-deep .ant-pagination {
      background: var(--py-sayfalama-arka, #1f1f1f);
      box-shadow: var(--py-sayfalama-golge, 0 2px 8px rgba(0, 0, 0, 0.4));
    }
  `],
})
export class FikoytSayfalamaComponent {
  @Input() toplam = 0;
  @Input() sayfa = 1;
  @Input() sayfaBoyutu = 10;
  @Input() sayfaBoyutSecenekleri = [10, 20, 50];
  @Input() sticky = true;

  @Output() sayfaDegisti = new EventEmitter<number>();
  @Output() sayfaBoyutuDegisti = new EventEmitter<number>();
}
